import { render, staticRenderFns } from "./def-modal-alert.vue?vue&type=template&id=64d6159e&scoped=true&"
import script from "./def-modal-alert.vue?vue&type=script&lang=js&"
export * from "./def-modal-alert.vue?vue&type=script&lang=js&"
import style0 from "./def-modal-alert.vue?vue&type=style&index=0&id=64d6159e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6159e",
  null
  
)

export default component.exports